import React, { Component } from 'react'

class VendorNavigation extends Component {

    next = () => {
        this.props.history.push({
            pathname: "/uniqueLocation"
        })
    }

    render() {
        return (
            <div>
                <h1>
                    Vendor Navigation
                </h1>
                <div>
                    <button className="btn btn-primary" onClick={this.next} >
                        NEXT
                    </button>
                </div>
            </div>
        )
    }
}

export default VendorNavigation
